import React, { ReactNode, useEffect } from "react";

import { AppVariablesContext } from "./context";
import { AppVariables } from "./types";
import initializeSentry from "../sentry";
import { emptyAppVariables } from "./constants";
import { VariablesStore } from "./with-app-variables";

interface AppVariablesProviderProps {
  children: ReactNode;
  variables: AppVariables;
}

export function AppVariablesProvider({ children, variables }: AppVariablesProviderProps) {
  useEffect(() => {
    if (variables) {
      VariablesStore.setVariables(variables);
    }

    initializeSentry(variables);
  }, [variables]);

  return <AppVariablesContext.Provider value={variables || emptyAppVariables}>{children}</AppVariablesContext.Provider>;
}
